import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { DropdownHeaderModule } from './dropdown-header/dropdown-header.module';
import { DropdownItemModule } from './dropdown-item/dropdown-item.module';
import { NestedTemplateTriggerDirective } from './dropdown-nested-templates/nested-template-trigger.directive';
import { DropdownComponent } from './dropdown.component';

@NgModule({
  imports: [CommonModule, DropdownHeaderModule, DropdownItemModule],
  declarations: [DropdownComponent, NestedTemplateTriggerDirective],
  exports: [
    DropdownComponent,
    DropdownHeaderModule,
    DropdownItemModule,
    NestedTemplateTriggerDirective,
  ],
})
export class DropdownModule {}

export { DropdownComponent } from './dropdown.component';
export { DropdownWidth } from './dropdown.component';
export { NestedTemplateTriggerDirective } from './dropdown-nested-templates/nested-template-trigger.directive';
